// @ts-strict-ignore
import { LMCommonUtilService } from '@utils/lm-common-util.service';
import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmCodeBlockFormatter = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  lmCommonUtilService: LMCommonUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {
  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  const listGridComponent = dataGrid.settings.userObject();

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  if (lmFormatterService.isTotalRow(dataView)) {
    return lmFormatterService.formatTotalRowColumn(row, cell, value, columnDef, dataView, dataGrid);
  }

  let markup = '';
  if (columnDef.flatLayout && columnDef.flatLayout.elements) {
    columnDef.flatLayout.elements.forEach((layoutField) => {

      let isVisible = true;
      let isValid = true;

      if (layoutField.field && layoutField.field.validity) {
        isValid = lmFormatterService.isConditionValid(layoutField.field.validity, dataView);
      }

      if (layoutField.field && layoutField.field.visibility) {
        isVisible = lmFormatterService.isConditionValid(layoutField.field.visibility, dataView);
      }

      if (isValid && isVisible) {
        const displayField = lmFormatterService.buildDisplayField(layoutField, dataView);
        const fieldValue = (dataView.fields[displayField.fieldId]) ? dataView.fields[displayField.fieldId].value : '';
        let displayValue = lmFormatterService.getDisplayText(displayField, fieldValue, dataView, listGridComponent.dataViewSet);

        if (lmFormatterService.isBlank(displayField.type, displayValue)) {
          displayValue =  '';
        }

        const label = (displayValue.length === 0) ? lmFormatUtilService.formatMessageRule(displayField.label, dataView) : '';
        const classes = (displayValue.length === 0) ? 'lm-list-code-block' : 'lm-list-code-block lm-field-data';

        markup += '<label class="' + classes + '">' + label + displayValue + '</label>';
      }
    });
    markup = '<span >' + markup + '</span>';
  }

  if (columnDef.displayField.alert) {
    markup = lmFormatterService.formatDisplayAlert(row, cell, markup, columnDef, dataView, dataGrid);
  }

  return markup;
};
